import { useAppT } from '../localization/config'
import Wrapper from './Wrapper'

export default function PhoneNumber({ shorten = false, anim = false }: { shorten?: boolean; anim?: boolean }) {
  const t = useAppT()

  return (
    <Wrapper
      wrap={!shorten}
      wrapper={(children) => (
        <p>
          {t.contact_phone} {children} ({t.contact_time})
        </p>
      )}
    >
      <a href="tel:420604664299" className={anim ? 'a-anim' : ''}>
        +420 604 664 299
      </a>
    </Wrapper>
  )
}
